<template>
  <div id="invoice-page">
    <div id="printMe2">
      <vx-card id="invoice-container">
        <table style="width: 100%" class="border-collapse">
          <tr>
            <td>
              <h6 style="text-align: center; font-size: 18px">
                Denizli Caner Otomotiv Arızalı / İade Ürün Onay Bildirimi
              </h6>
              <h6>Onay talep edilen işlem onaylanmıştır</h6>
            </td>
          </tr>
        </table>

        <table border="1" style="border-top: 1px solid" class="border-collapse">
          <tr>
            <td>
              <table style="text-align: center">
                <tr>
                  <td style="padding: 8px; border: 1px solid; font-weight: 600">
                    İşlem
                  </td>

                  <td style="padding: 8px; border: 1px solid">
                    {{ islemTuru }}
                  </td>
                </tr>
                <tr>
                  <td style="padding: 8px; border: 1px solid; font-weight: 600">
                    Fiş No
                  </td>

                  <td style="padding: 8px; border: 1px solid">
                    {{ fisNumarası }}
                  </td>
                </tr>

                <tr>
                  <td style="padding: 8px; border: 1px solid; font-weight: 600">
                    Müşteri
                  </td>

                  <td style="padding: 8px; border: 1px solid">
                    {{ musteriAdi }}
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          <br />
        </table>
        <br />
      </vx-card>
    </div>
  </div>
</template>
<script>
import Store from "../../../../store/store";
import state from "../../../../store/state";
import moment from "moment";
export default {
  data() {
    return {
      islem: "",
      fisNo: "",
      musteri: "",
      iadeSekli: "",
      iadeSebep: "",
      aciklama: "",
      gonderen: "",
      dosya: "",
      FTARIH: "",
      kalemList: [],
      MASRAF: "",
    };
  },
  computed:{
    fisNumarası(){
      return Store.state.account.onayMailFisNo;
    },
    musteriAdi(){
      return Store.state.account.onayMailMusteri;
    },
    islemTuru(){
      return Store.state.account.onayMailIslem;
    }
    
  },
  methods: {
    getItems2(gelen, islem) {
      console.log(islem);
      this.islem = islem;
      this.fisNo = gelen[0].RECEIPTNO;
      this.musteri = gelen[0].ACTNAME;
    },
    currencyFormatter(currency, sign) {
      if (currency == "") {
        return "";
      } else {
        var sansDec = currency.toFixed(2);
        var formatted = sansDec.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return sign + `${formatted}`;
      }
    },
    
  },
};
</script>